export const VAT_RATE_SINCE_2025_07 = 0.24;
